export const REGEX_PATTERNS = {
  // Allows letters, spaces, hyphens, and apostrophes, including Unicode ranges for Arabic
  NAME: /^[A-Za-zÀ-ÖØ-öø-ÿ\u0600-\u06FF\s'-]+$/,

  // Civil ID pattern for Kuwait (12 digits, optional dashes)
  CIVIL_ID: /^\d{12}$|^\d{4}-\d{4}-\d{4}$/,

  // Phone number pattern (to be used alongside phone input validation)
  PHONE: /^\+[1-9]\d{1,14}$/,

  // Email pattern with unicode support
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,

  // Latin letters only with spaces, hyphens, and apostrophes (for city names)
  LATIN_ONLY: /^[A-Za-z\s'-]+$/,
} as const
